import { render, staticRenderFns } from "./XMLFeedTab.vue?vue&type=template&id=218cda16&"
import script from "./XMLFeedTab.vue?vue&type=script&lang=js&"
export * from "./XMLFeedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports